import styled, { css } from 'styled-components';

import {
    designColor,
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledReset,
    styledTypography,
} from '../styles';

export const PrimitiveTextArea = styled.textarea`
    ${styledReset.textArea};
    ${styledTypography.allianceBase};

    &:disabled {
        cursor: not-allowed;
    }

    &:read-only {
    }
`;

///
/// Recipes

const basic = css`
    outline: 2px solid transparent;
    outline-offset: 2px;
    transition-property: color, background-color, border-color, outline-color, opacity;
    transition-duration: ${duration.normal}ms;
    transition-timing-function: ${easing.cubic};

    &:focus-visible {
        outline-color: ${designColor.brandPurple};
    }
`;

export const recipesTextArea = {
    basic,
};
